import { useEffect, useState } from "react";
import {useDispatch} from "react-redux";
import {useHttp} from "./useHttp";
import {createSetPartOrderData} from "../actions/dataActions";


export const usePartOrderData = (id, dataFresh) => {
    let noFetch = !id
    const dispatch = useDispatch();
    const [data, loading, error] = useHttp(
        `partorder/${id}`,
        "get",
        {},
        dataFresh,
        noFetch
    );
    if(error){
        throw Error("There was an error getting part order data");
    }
    // undefined until the first fetch result reaches the store - "loaded" waits for that
    // so the screen never renders against an empty/previous record
    const [synced, setSynced] = useState(undefined);
    // Dispatch only when the fetch result changes - not in the render body, where every
    // re-render re-dispatched (wiping unsaved edits) and could loop (React error #301).
    useEffect(() => {
      if(!loading && data !== null){
          dispatch(createSetPartOrderData(data));
      } else {
          dispatch(createSetPartOrderData({
              customer: {},
              customer_vehicle : "",
              customer_vehicle_vin: "",
              parts: [],
              status: "QUOTE",
              description: "",
              department: {name:"VAN PARTS DIRECT", id:9},
              cash_sale: []
          }))
      }
      if (!loading) setSynced(data);
    }, [data, loading, dispatch]);

    return !loading && synced !== undefined
}